<template>
    <div>
        <md-card class="separated">
            <md-card-header>
                <vs-avatar size="100" circle>
                    <img style="object-fit: cover;" :src="'/api/personas/' + personaId + '/avatar'" @error="setAltImg" alt="">
                </vs-avatar>                
                <md-card-header-text>
                    <div><h4 class="font-medium"> {{ info.nombre || '' }} </h4></div>
                    <div class="md-subhead">Matricula:</div>
                    <div class="md-subhead">{{ info.matricula || '' }}</div>
                </md-card-header-text>       
            </md-card-header>
        </md-card>
        <div class="separated">
            <md-list v-if="permisosInfo.includes('ver-becas')">
                <md-subheader>Becas</md-subheader>
                <div v-if="getOnSeccion('becas')">
                    <md-list-item  v-for="(value, key) in getOnSeccion('becas')" :key="`${key}-becas`">
                        <div class="md-list-item-text">
                            <md-chip v-if="value.status === 'inactiva'" class="mb-1 fontMedium mini-chip col-yellow" ><strong> Beca inactiva </strong></md-chip>
                            <md-chip v-if="value.status === 'activa'" class="mb-1 fontMedium mini-chip col-green" ><strong> Beca activa </strong></md-chip>
                            <span><small class="text-muted">{{ value.nombre || 'Sin información' }}</small></span>
                            <span>{{ value.ciclo_escolar || 'Sin información' }}</span>                                
                        </div>          
                    </md-list-item>
                </div>    
                <div v-else>
                    <md-list-item>
                        <div class="md-list-item-text">
                            <span><small class="text-muted">No hay becas asignadas</small></span>
                        </div> 
                    </md-list-item>
                </div>
                
            </md-list>
        </div>
        <div class="separated">
            <lista v-if="permisosInfo.includes('ver-registro-academico-actual')" class="rounded" header="Registro Académico Actual" :info="getOnSeccion('registro_actual')" :labels="registroActual"  >
                <template v-slot:row="{ label, attribute, getByAttribute }">
                    <div v-if="attribute === 'status'" class="md-list-item-text">
                            <span><small class="text-muted">{{ label }}</small></span>
                            <md-badge v-if="Object.keys(info).length" :class="getColorClass(getByAttribute(attribute))" :md-content="labelStatus(getByAttribute(attribute))" />                                
                    </div> 
                    <div v-else class="md-list-item-text">
                        <span><small class="text-muted">{{label}}</small></span>
                        <span  v-if="label != 'Grupo Administrativo (No. lista)'">{{getByAttribute(attribute) || capitalize }}</span>   
                        <span v-else>{{info.grupo_administrativo}}</span>                
                    </div>
                </template>
            </lista>
            <center><md-divider width="80%"></md-divider></center>
            <lista v-if="permisosInfo.includes('ver-tutor')" header="Tutor" :info="getOnSeccion('tutor')" :labels="tutor"  >
                <template v-slot:row="{ label, attribute, getByAttribute }">
                    <div v-if="attribute === 'telefonos'" class="md-list-item-text">
                        <span><small class="text-muted">{{label}}</small></span>
                        <span v-for="(value, key, i) in telefonos" :key="`${key+i}-tel`">
                            <small>{{ key }}</small>
                            <small>{{`${getByAttribute(attribute, true) instanceof Object ? getByAttribute(attribute, true)[value] || 'Sin información' : 'Sin información'}`}}</small>
                        </span>                                
                    </div> 
                    <div  v-else-if="attribute === 'parentesco'" class="md-list-item-text">
                        <span><small class="text-muted">{{label}}</small></span>
                        <span>{{getByAttribute(attribute) | capitalize}}</span>                                
                    </div>
                    <div v-else class="md-list-item-text">
                        <span><small class="text-muted">{{label}}</small></span>
                        <span>{{getByAttribute(attribute)}}</span>                                
                    </div>
                </template>
            </lista>
            <center><md-divider width="80%"></md-divider></center>
            <lista v-if="permisosInfo.includes('ver-datos-fiscales')" header="Datos fiscales" :info="getOnSeccion('fiscales')" :labels="datosFiscales"  ></lista>
            <center><md-divider width="80%"></md-divider></center>
  
            <!-- <md-list v-if="permisosInfo.includes('ver-becas')">
                <md-subheader>Becas</md-subheader>
                <div v-if="getOnSeccion('becas')">
                    <md-list-item  v-for="(value, key) in getOnSeccion('becas')" :key="`${key}-becas`">
                        <div class="md-list-item-text">
                            <md-chip v-if="value.status === 'inactiva'" class="mb-1 fontMedium mini-chip col-yellow" ><strong> Beca inactiva </strong></md-chip>
                            <md-chip v-if="value.status === 'activa'" class="mb-1 fontMedium mini-chip col-green" ><strong> Beca activa </strong></md-chip>
                            <span><small class="text-muted">{{ value.nombre || 'Sin información' }}</small></span>
                            <span>{{ value.ciclo_escolar || 'Sin información' }}</span>                                
                        </div>          
                    </md-list-item>
                </div>    
                <div v-else>
                    <md-list-item>
                        <div class="md-list-item-text">
                            <span><small class="text-muted">No hay becas asignadas</small></span>
                        </div> 
                    </md-list-item>
                </div>
                
            </md-list> -->
        </div>
        <vs-dialog v-model="actualizarFacturacion" prevent-close not-close>
            <template #header>
            <h4 class="not-margin">
                Actualización de datos
            </h4>
            </template>


            <div class="con-form">
                <p>Por disposición oficial del SAT, deberá de actualizar sus datos fiscales conforme a su cedula fiscal, adicionalmente deberá de indicar su regimen fiscal y código postal, esto con el objetivo de tener sus datos fiscales actualizados una vez que el SIGeM este facturando con la versión 4.0 del CFDI a partir del 15 de mayo.</p>

                <p>Nota: Es importante mencionar que es responsabilidad del receptor indicar sus datos fiscales tal y como se encuentran en su constancia de situación fiscal más actual, respetando mayúsculas y caracteres.</p>
                <actualizacion-factura @cerrarModal="closeModal" :personaId="personaId" :info="infoForm" @refreshTable="getRefresh" ></actualizacion-factura> 
            </div>
        </vs-dialog>
    </div>
</template>

<script>
import lista from './lista.vue'
import cobranza from '../../../api/requests/cobranza-persona.js'
import ActualizacionFactura from './actualizacion-datos-fiscales.vue'
import landing from '../../../api/requests/landing'
export default {
    props:[
        "personaId",
        "personaRol",
        "permisos",
        "cicloEscolar",
        "programa",
        "institucion",
        'infoForm',
        'info'
    ],
    components:{
        lista,
        ActualizacionFactura
    },
    data () {
        return {
            host: '',
            ruta: '',
            actualizarFacturacion: false,
            permisosInfo: [],
            datosFiscales:{
                "Uso de CFDI": "uso_cfdi" ,
                "RFC" : "rfc",
                "Razón Social" : "razon_social" ,
                "Correo Fiscal" : "correo_fiscal",
                "CURP": "curp",
                "Régimen fiscal": "regimen_fiscal",
                "C.P.": "codigo_postal"
            },
            registroActual:{
                        "Ciclo Escolar" : "ciclo_escolar",
                        "Nivel Académico": "nivel_academico_id",
                        "Programa": "programa",
                        "Institución" : "institucion",
                        "Estado" : "status",
                        "Grado": "grado",
                        "Grupo Administrativo (No. lista)": 'grupo_administrativo'
            },
            becas:{
                    "Ciclo Escolar" : "ciclo_escolar",
                    "Descripción" : "descripcion",
                    "Nombre" : "nombre",
                    "Estado" : "status",
                    "Id" : "id"
            },
            tutor: {
                "Nombre": "nombre",
                "Parentesco" : "parentesco",
                "Telefonos": "telefonos",
                "Correo" : "email"
            },
            telefonos: {
                    "Casa" : "casa",
                    "Celular" : "celular",
                    "Trabajo": "trabajo"
            },
            statusColors: {
                "Prospecto" : "blue",
                "Interesado": "blue",
                "Aplicante" : "blue",
                "Admitido" : "blue",
                "reingreso" : "green",
                "nuevoingreso": "green",
                "Inscrito económico" : "green",
                "Inscrito académico" : "green",
                "Acreditado en ciclo escolar" : "green",
                "Reactivación" : "green",
                "Congelado" : "yellow",
                "Descartado" : "yellow",
                "Bloqueo para inscripción" : "yellow",                
                "No acreditado en ciclo escolar" : "red",
                "Baja definitiva voluntaria" : "red",
                "Baja definitiva por conducta" : "red",
                "Baja temporal voluntaria" : "red",
                "Suspensión por morosidad" : "red"         
                
            },
        }
    },
    created(){
        this.ruta = window.location.protocol
        this.host = window.location.host
    },
    methods:{
        getRefresh(){
            this.$emit('refreshTable')
            this.actualizarFacturacion = false
        },
        closeModal(){
            this.actualizarFacturacion = false
        },
        async getInfo () {
            this.permisosInfo = this.permisos
            if (this.info && this.info.secciones 
                    && this.info.secciones.fiscales 
                        && this.info.secciones.fiscales.facturacion_automatica >= 0){
                    this.info.secciones.fiscales.facturacion_automatica = parseInt(this.info.secciones.fiscales.facturacion_automatica ) === 1 ? 'Si' : 'No';
                }
        },
        getOnSeccion(seccion) {
            if (
                seccion
                && seccion.constructor
                && seccion.constructor.name === 'String'
                && this.info instanceof Object 
                && this.info.secciones instanceof Object 
                && this.info.secciones[seccion] instanceof Object
            ) {
                return this.info.secciones[seccion]
            }
            return null
        },
        getColorClass(value) {
            let classes = {
             'md-square': true
            }
            if (
                value 
                && this.statusColors[value] 
                && Object.keys(this.info).length
            ) {
                classes['md-'+this.statusColors[value]] = true
            }
            
            return classes
        },
        labelStatus(value) {
            if (value == 'reingreso'){
                return 'Reingreso'
            }else if (value == 'nuevoingreso'){
                return 'Nuevo Ingreso'
            }else{
                return value
            }
        },
        condicionesForm(){
            if(this.infoForm){
                if(JSON.parse(this.personaRol).roles[0].name == 'Usuario Principal'){
                    if((this.infoForm.rfc != '' || this.infoForm.rfc != null) && (this.infoForm.razon_social != '' || this.infoForm.razon_social != null)){
                        if((this.infoForm.codigo_postal == '' || this.infoForm.codigo_postal == null) || (this.infoForm.regimen_fiscal == '' || this.infoForm.regimen_fiscal == null)){
                            this.actualizarFacturacion = true
                        }else if(this.infoForm.codigo_postal != '' && this.infoForm.regimen_fiscal != ''){
                            this.actualizarFacturacion = false
                        }
                    }else{
                        this.actualizarFacturacion = false
                    }
                }
            }
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
    },
    watch: {
        info(){
            this.getInfo()
        },
        infoForm(){
            this.condicionesForm()
        }
    }
}
</script>

<style lang="scss"  scoped >
.separated {
    margin: 0.7em !important;   
    // background-color: #eceef7da !important;
}
.md-list {
     padding: 0.7rem;
}

.md-divider {
    height: 1px;
    color: #4b647a98 !important;
}

.md-card .md-card-header .vs-avatar-content{
    height: 100% !important; 
}

.md-card-header-text {
    margin-left: 1em;
}

.md-list-item-text {
  white-space: normal !important;
  padding-bottom: 0.5rem;
}

@mixin badge-colors ($theme, $text-color, $background) {
    &.md-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-badge{
    &.md-theme-default{
        @include badge-colors ('blue', #fff,  #027fbf);
        @include badge-colors ('green', #fff,  #61ce63);
        @include badge-colors ('yellow', #fff, #febb34);
        @include badge-colors ('red', #fff, #f24952);
    }
}

.col-yellow{
    font-size: 14px;
    background: rgb(255, 248, 236);
    color: #febf3d;
    height: 32px;
    padding:0 12px;
    border-radius: 32px;
    line-height: 32px;
    text-align: center;
}

.col-green{
    color: #55ce63;
    background: rgb(232, 253, 235);
    height: 32px;
    padding:0 12px;
    border-radius: 32px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
}

</style>

<style>
.vs-avatar img{
    width: 100px;
	height: 130px;
	object-fit: cover;
}
</style>